import { useState } from "react";
import { useQueryClient } from "react-query";
import ReplayIcon from "@mui/icons-material/Replay";
import { Box } from "@mui/material";

import Layout from "../../templates/Layout"; // Layoutコンポーネントをインポート
import LogTable from "./LogTable";
import Button from "../../Button/Button";
import { Progress } from "../../templates/Progress";
import { useListCleaningEventByMapQuery } from "hooks/worker/useCleaningEvent";
import { useListRobotQuery } from "hooks/worker/useRobot";
import { useListMapQuery } from "hooks/worker/useMap";
import { useSafeQueryId } from "hooks/useSafeId";
import { handleError } from "utils/error/handleError";
import { callSyncCleaningEvent } from "api/worker/cleaningEvent";
import { cleaningEventKey } from "hooks/worker/keys";
import { notify } from "lib/notify";

const MapCleaningLog = () => {
  const mapId = useSafeQueryId("mapId");
  const { data: maps = [], refetch: refetchMaps } = useListMapQuery();
  const map = maps.find((m) => m.mapId === mapId);
  const { data: logs = [], refetch: refetchLogs } =
    useListCleaningEventByMapQuery({ mapId });
  const { data: robots = [] } = useListRobotQuery();
  const [loading, setLoading] = useState(false);
  const queryClient = useQueryClient();
  const onRefetch = async () => {
    await Promise.all([refetchLogs(), refetchMaps()]);
  };

  const onClickSync = async () => {
    setLoading(true);
    try {
      await callSyncCleaningEvent();
      queryClient.invalidateQueries(cleaningEventKey.all);
      notify("保存しました");
    } catch (e) {
      handleError(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout title={`${map?.mapName || ""} 清掃ログ`}>
      <Box sx={{ display: "flex", mb: 1 }}>
        <Button
          onClick={onClickSync}
          variant="outlined"
          startIcon={<ReplayIcon />}
          sx={{ ml: "auto" }}
        >
          再取得
        </Button>
      </Box>
      {logs.length > 0 && (
        <Box sx={{ position: "relative" }}>
          <LogTable
            logs={logs}
            enableRobotName
            robots={robots}
            maps={maps}
            refetchFunc={onRefetch}
            enableMenu
          />
          <Progress enabled={loading} />
        </Box>
      )}
    </Layout>
  );
};

export default MapCleaningLog;
